export default __webpack_public_path__ + "static/media/video4.ac5fb046.webp";